import { Route, Routes } from "react-router-dom";

import { RequireAuth } from "@/auth/RequireAuth";
import { AppLayout } from "@/components/AppLayout";
import { AcceptInvitePage } from "@/pages/AcceptInvitePage";
import { AccountPage } from "@/pages/AccountPage";
import { AdminProjectAccessPage } from "@/pages/AdminProjectAccessPage";
import { AdminUsersPage } from "@/pages/AdminUsersPage";
import { ForgotPasswordPage } from "@/pages/ForgotPasswordPage";
import { HomePage } from "@/pages/HomePage";
import { LoginPage } from "@/pages/LoginPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { ProjectPage } from "@/pages/ProjectPage";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage";

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/accept-invite" element={<AcceptInvitePage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />

      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route path="/" element={<HomePage />} />
        <Route path="/projects/:slug" element={<ProjectPage />} />
        <Route path="/projects/:slug/reports" element={<ProjectPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route
          path="/admin/users"
          element={
            <RequireAuth adminOnly>
              <AdminUsersPage />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/access"
          element={
            <RequireAuth adminOnly>
              <AdminProjectAccessPage />
            </RequireAuth>
          }
        />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
